import { RCreateUserBody } from '../remote/user';
import { RegistrationForm } from '../../../screens/signup/types';
import { makeStrapiRelationById } from '../../../utils/mapping';
import { Institution } from '../../Institution/domain/institution';
import { RInstitution } from '../../Institution';

export const mapCreateUserFormToBody = (
    form: RegistrationForm,
    createdInstitution?: RInstitution
): RCreateUserBody => {
    const email = form[0].email.value;
    const firstname = form[0].firstName.value;
    const lastname = form[0].lastName.value;
    const password = form[0].password.value;
    const institution = form[1].institution.value as Institution;
    const isCreator = createdInstitution !== undefined;

    if (
        email === undefined ||
        firstname === undefined ||
        lastname === undefined ||
        password === undefined ||
        (institution === undefined && !isCreator)
    ) {
        throw new Error('Mandatory values are missing in the data you tried to submit!');
    }

    return {
        email: email,
        username: email,
        password: password,
        firstname: firstname,
        lastname: lastname,
        title: form[0].title.value ?? null,
        pronouns: form[0].pronoun.value ?? null,
        institution: makeStrapiRelationById(createdInstitution ?? institution),
        hasApproval: isCreator,
        phone: null,
        administratedInstitution: isCreator ? createdInstitution : null,
    };
};
